import { render, staticRenderFns } from "./security-2fa.vue?vue&type=template&id=ea8038ae&"
import script from "./security-2fa.vue?vue&type=script&lang=js&"
export * from "./security-2fa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports